/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_4_TitleInputs */

const es_home_features_item_4_title = /** @type {(inputs: Home_Features_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto Completo`)
};

const en_home_features_item_4_title = /** @type {(inputs: Home_Features_Item_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Context`)
};

/**
* | output |
* | --- |
* | "Full Context" |
*
* @param {Home_Features_Item_4_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_4_title = /** @type {((inputs?: Home_Features_Item_4_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_4_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_4_title(inputs)
	return en_home_features_item_4_title(inputs)
});
export { home_features_item_4_title as "home.features.item_4_title" }